import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { CharterPerformancePCRoutingModule } from './charter-performance-pc-routing.module';
import { CharterPerformancePCComponent } from './charter-performance-pc.component';

import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { MatPaginatorModule } from '@angular/material/paginator';
import { MatSortModule } from '@angular/material/sort';
import { MatAutocompleteModule } from '@angular/material/autocomplete';
import { MatInputModule } from '@angular/material/input';

import { CustomDatePickerModule } from 'src/app/shared/components/custom-date-picker/custom-date-picker.module';
import { CustomDropdownModule } from 'src/app/shared/components/custom-dropdown/custom-dropdown.module';
import { CustomInputModule } from 'src/app/shared/components/custom-input/custom-input.module';
import { CustomTimpickerModule } from 'src/app/shared/components/custom-timpicker/custom-timpicker.module';
import { MaterialModule } from 'src/app/shared/material/material.module';
import { PcMultiSelectFilterModule } from 'src/app/shared/components/pc-multi-select-filter/pc-multi-select-filter.module';
import { AppBackButtonModule } from 'src/app/shared/components/app-back-button/app-back-button.module';

@NgModule({
  declarations: [CharterPerformancePCComponent],
  imports: [
    CommonModule,
    CharterPerformancePCRoutingModule,
    FormsModule,
    ReactiveFormsModule,
    MaterialModule,
    MatPaginatorModule,
    MatSortModule,
    MatAutocompleteModule,
    MatInputModule,
    CustomDropdownModule,
    CustomDatePickerModule,
    CustomTimpickerModule,
    CustomInputModule,
    PcMultiSelectFilterModule,
    AppBackButtonModule,
  ]
})
export class CharterPerformancePCModule {}